export default "__VITE_ASSET__LPtpUmZM__"